module.exports = __webpack_public_path__ + "static/img/color.5e9bd84a.png";